import { render, staticRenderFns } from "./VK.vue?vue&type=template&id=62eccd6b&"
import script from "./VK.vue?vue&type=script&lang=ts&"
export * from "./VK.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports